<template>
  <div>
    <el-container>
      <el-header class="bg-gray-600 flex justify-between items-center">
        <div class="text-lg text-white">
          后台管理系统
        </div>

        <div class="flex w-60 items-center justify-between">
          <div>
            <el-avatar shape="square" :size="40" :src="squareUrl"></el-avatar>
          </div>
          <div class="text-lg text-white">
            {{ userName }}
          </div>
          <div>
            <el-button type="info" @click="logout">退出</el-button>
          </div>
        </div>
      </el-header>
    </el-container>
  </div>
</template>

<script>

export default {
  mounted(){

    this.userName = localStorage.getItem('userInfo')
  },
  data() {
    return {
      userName: "",
      squareUrl:require('../../static/img/touxiang.png')
    };
  },
  methods: {
    logout() {
      this.$confirm("确认退出系统吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          localStorage.clear("token");
          localStorage.clear("userInfo");
          this.$message({
            type: "success",
            message: "退出成功!"
          });
          this.$router.push("/login");
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消退出！"
          });
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/layouts/top.vue